import { render } from "./NewChatForm.vue?vue&type=template&id=fb5273c0&scoped=true"
import script from "./NewChatForm.vue?vue&type=script&lang=js"
export * from "./NewChatForm.vue?vue&type=script&lang=js"

import "./NewChatForm.vue?vue&type=style&index=0&id=fb5273c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb5273c0"

export default script